import React from "react";

function UserManageSelected({ fill = "#424242" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1393_7924)">
        <path
          d="M17.5463 15.3902C17.5463 13.9391 16.1551 12.7054 14.2142 12.2472M12.5481 15.3902C12.5481 13.5492 10.3106 12.0581 7.54992 12.0581C4.78925 12.0581 2.55173 13.5492 2.55173 15.3902M12.5481 9.55902C13.4318 9.55902 14.2794 9.20796 14.9043 8.58307C15.5292 7.95817 15.8802 7.11063 15.8802 6.2269C15.8802 5.34316 15.5292 4.49563 14.9043 3.87073C14.2794 3.24584 13.4318 2.89478 12.5481 2.89478M7.54992 9.55902C6.66618 9.55902 5.81864 9.20796 5.19375 8.58307C4.56885 7.95817 4.21779 7.11063 4.21779 6.2269C4.21779 5.34316 4.56885 4.49563 5.19375 3.87073C5.81864 3.24584 6.66618 2.89478 7.54992 2.89478C8.43365 2.89478 9.28119 3.24584 9.90608 3.87073C10.531 4.49563 10.882 5.34316 10.882 6.2269C10.882 7.11063 10.531 7.95817 9.90608 8.58307C9.28119 9.20796 8.43365 9.55902 7.54992 9.55902Z"
          stroke={fill}
          strokeWidth="1.66606"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1393_7924">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UserManageSelected;
